import { render, staticRenderFns } from "./SalerItem.vue?vue&type=template&id=b72fe5bc&"
import script from "./SalerItem.vue?vue&type=script&lang=js&"
export * from "./SalerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports